module.exports = __webpack_public_path__ + "assets/18cace078f5c3c8204f4acea71e68256.jpg";